import { api } from "../../../services/api";
import { toast } from "react-toastify";

export async function fetchCompletarCadastro({ formData, selectedOption }) {
  return new Promise((resolve, reject) => {
    const token = localStorage.getItem("@medusapayments:access_token");

    api
      .post(
        "/complete-register",
        {
          cnpj: formData.cnpj,
          razaosocial: formData.razaosocial,
          nomefatura: formData.nomefatura,
          mediafaturamento: formData.mediafaturamento,
          ticketmedio: formData.ticketmedio,
          siteempresa: formData.siteempresa,
          quaisprodutos: formData.quaisprodutos,
          tipoproduto: selectedOption,

          nomeresp: formData.nomeresp,
          emailresp: formData.emailresp,
          cpfresp: formData.cpfresp,
          telefoneresp: formData.telefoneresp,
          nascimentoresp: formData.nascimentoresp,
          maeresp: formData.maeresp,

          cep: formData.cep,
          endereco: formData.endereco,
          numero: formData.numero,
          bairro: formData.bairro,
          cidade: formData.cidade,
          complemento: formData.complemento
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then((response) => {
        toast.success(response.data);
        resolve(response.data);
      })
      .catch((error) => {
        toast.error(error.response.data);
        reject(error.response.data);
      });
  });
}
